import React, { useEffect } from 'react';
import { verifyAttrs, registerContract, readAllContracts } from '../verify/contract';

// Arnes de verificacion VRTC (dev). Monta los CUATRO contratos con datos representativos
// para poder ejecutar readAllContracts() de forma determinista y comprobar total=4, fallos=0.
// Las pantallas reales emiten exactamente los mismos contratos con datos vivos de Supabase.
const MUESTRAS = [
  { unit: 'PanelOcupacion', total: 1258, suma: 1258, 'ocupacion-cuadra': true },
  { unit: 'ResumenZona', reales: 448, esperadas: 448, 'ubicaciones-cuadra': true },
  { unit: 'FichaUbicacion', total: 100, suma: 100, 'stock-cuadra': true },
  { unit: 'FichaLPN', contenido: 100, 'stock-hueco': 100, 'lpn-cuadra': true },
];

export default function Verify() {
  useEffect(() => {
    MUESTRAS.forEach((m) => {
      const reglas = {}; const campos = {};
      Object.entries(m).forEach(([k, v]) => {
        if (k === 'unit') return;
        if (k.endsWith('-cuadra')) reglas[k] = v; else campos[k] = v;
      });
      registerContract(m.unit, { campos, reglas });
    });
    // eslint-disable-next-line no-console
    console.log('readAllContracts()', readAllContracts());
  }, []);

  return (
    <div data-testid="verify-harness" style={{ padding: 20 }}>
      {MUESTRAS.map((m) => <div key={m.unit} {...verifyAttrs(m)} data-testid={`contrato-${m.unit}`} />)}
      <p className="muted">VRTC harness — readAllContracts()</p>
    </div>
  );
}
